module.exports = __webpack_public_path__ + "img/main-winter.05598fd4.jpg";